import script from "./VideoEditorOrganism.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoEditorOrganism.vue?vue&type=script&setup=true&lang=ts"

import "./VideoEditorOrganism.vue?vue&type=style&index=0&id=00cecde6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00cecde6"]])

export default __exports__